import NewUser from './NewUser';

export default NewUser;
